import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormHelperText,
    IconButton,
    Input,
    Stack,
} from '@mui/material';

import React, { useState } from 'react';
import useBundleTranslation from 'i18n';
import IconMi from 'components/common/icon/IconMi';
import { homePage } from 'api/home-page';
import { useHomeContext } from 'app/home/context';
import LoadingPlaceholder from 'components/common/loading-placeholder/LoadingPlaceholder';
import { Popup } from 'components/common/popup/Popup';

export default function HideCategoriesPopup({
    setHideCategoriesPopupActive,
}: {
    setHideCategoriesPopupActive: (hideCategoriesPopupActive: boolean) => void;
}) {
    const { t } = useBundleTranslation('app/home');
    const ctx = useHomeContext();

    const [refetchData] = [ctx.refetchData];
    const [showLoading, setShowLoading] = useState(false);
    const dataTestAttr = 'add_folder_popup';
    const onPopupHide = () => {
        setHideCategoriesPopupActive(false);
    };

    const onHideCategories = async () => {
        setShowLoading(true);
        await homePage.hideCategories();
        setShowLoading(false);
        setHideCategoriesPopupActive(false);
        refetchData();
    };

    return showLoading ? (
        <LoadingPlaceholder />
    ) : (
        <Popup
            settings={{
                title: t('confirmation'),
                textOK: t('hide_categories'),
            }}
            maxWidth="popupSm"
            open={true}
            onHide={onPopupHide}
            onConfirm={onHideCategories}
        >
            <Box>{t('hide_categories_confirm')}</Box>
        </Popup>
    );
}
